import React from 'react';
import axios from 'axios';

export default class IntencionVacunarse extends React.Component {
  constructor(props) {
    super(props)
    this.state={
      localidades:[],
      loading:true
    }
  }

  componentDidMount(){
    axios.get(localStorage.getItem('apiUrl') + '/api/geo/localidades/listar')
    .then((resul) => {
      this.setState({localidades:resul.data.localidades, loading:false})
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error")
    })
  }
  
  setFecha(valor){
    const previo = this.props.datos.fecha_nacimiento;
    const longitud = valor.length;
    const longitudPrevio = previo.length;
    if (longitud < longitudPrevio)
      return this.props.editar("fecha_nacimiento", valor);
    if (!isNaN(valor[longitud-1]) && longitud < 11 && valor[longitud-1] !== " "){
      if (longitud === 2 || longitud === 5)
        valor += "/";
      this.props.editar("fecha_nacimiento", valor)
    }
  }

  render(){
    const {show, editar, datos} = this.props;
    const {localidades} = this.state;
    // apellidos
    // nombres
    // documento
    // fecha_nacimiento
    // telefono
    // calle
    // numero
    // localidad_id
    return(
      <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
        <div style={{
          display:'flex', flexDirection:'row', width:'calc(100% - 30px)',
          padding:'10px 15px', backgroundColor:'#00b1e9', color:'white',
          fontSize:18, fontFamily:'Barlow_Condensed', fontWeight:'bold'
        }}>
          <strong>4. </strong> &nbsp;
          Datos personales
        </div>
        <div style={{
          display: show ? 'flex' : 'none',
          flexDirection:'column', width:'100%', margin:'10px 0'
        }}>
          <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
            <input
              style={{flex:1}}
              value={datos.documento}
              onChange={(e) => editar('documento', e.target.value)}
              type="number"
              placeholder="Documento"
            />
            <input
              style={{flex:1}}
              value={datos.apellidos}
              onChange={(e) => editar('apellidos', e.target.value)}
              placeholder="Apellidos"
            />
            <input
              style={{flex:1}}
              value={datos.nombres}
              onChange={(e) => editar('nombres', e.target.value)}
              placeholder="Nombres"
            />
          </div>
          <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
            <input
              style={{flex:1}}
              value={datos.fecha_nacimiento}
              onChange={(e) => this.setFecha(e.target.value)}
              placeholder="Fecha de nacimiento"
            />
            <input
              style={{flex:1}}
              value={datos.telefono}
              onChange={(e) => editar('telefono', e.target.value)}
              placeholder="Teléfono"
            />
          </div>
          <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
            <select
              style={{flex:2}}
              value={datos.localidad_id}
              onChange={(e) => editar('localidad_id', e.target.value)}
            >
              <option value={0}>LOCALIDAD</option>
              {localidades.map((item, index) => {
                return(
                  <option key={index} value={item.id}>{item.descripcion}</option>
                )
              })}
            </select>
            <input
              style={{flex:1}}
              value={datos.calle}
              onChange={(e) => editar('calle', e.target.value)}
              placeholder="Calle (domicilio)"
            />
            <input
              style={{flex:1}}
              value={datos.numero}
              onChange={(e) => editar('numero', e.target.value)}
              placeholder="Numero (domicilio)"
            />
          </div>
        </div>
      </div>
    )
  }
}
